import { useSite } from '../context/SiteContext';
import { asset } from '../lib/utils';
import { CheckIcon, ExcelTile } from './Icons';

const highlights = ['সহজ বাংলায় ধাপে ধাপে ব্যাখ্যা', 'বাস্তব অফিসের উদাহরণ দিয়ে শেখানো', 'প্রতিটি ক্লাসে লাইভ প্রশ্নোত্তর', 'কোর্স শেষেও সাপোর্ট গ্রুপে সাহায্য'];

export default function Instructor() {
  const { instructor } = useSite().course;
  const initials = (instructor.name || '')
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2);

  return (
    <section id="instructor" className="py-20">
      <div className="container-x grid items-center gap-12 lg:grid-cols-[5fr_7fr]">
        <div className="relative mx-auto w-full max-w-[16rem] sm:max-w-sm">
          <div className="absolute -inset-3 rotate-3 rounded-3xl bg-gradient-to-br from-word-500 to-excel-500 opacity-90" />
          <div className="relative aspect-[4/5] overflow-hidden rounded-3xl bg-slate-100">
            {instructor.photo ? (
              <img src={asset(instructor.photo)} alt={instructor.name} className="h-full w-full object-cover" />
            ) : (
              <div className="flex h-full w-full flex-col items-center justify-center bg-gradient-to-br from-word-50 to-excel-50">
                <span className="flex h-36 w-36 items-center justify-center rounded-full bg-white text-5xl font-bold text-word-500 shadow-lg">{initials}</span>
                <span className="mt-4 text-lg font-bold text-slate-800">{instructor.name}</span>
              </div>
            )}
          </div>
          <div className="absolute -bottom-5 -right-3 flex items-center gap-2 rounded-2xl bg-white px-4 py-3 shadow-xl ring-1 ring-slate-900/5">
            <ExcelTile className="h-8 w-8 text-sm" />
            <span className="text-sm font-semibold text-slate-700">Excel ট্রেইনার</span>
          </div>
        </div>

        <div>
          <span className="eyebrow">আপনার মেন্টর</span>
          <h2 className="section-title">
            {instructor.name} {instructor.nameBn && <span className="text-slate-400">({instructor.nameBn})</span>}
          </h2>
          <p className="mt-1 font-medium text-word-500">{instructor.title}</p>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">{instructor.bio}</p>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2">
            {highlights.map((h) => (
              <li key={h} className="flex items-center gap-2.5 rounded-xl bg-slate-50 px-4 py-3 text-slate-700">
                <CheckIcon className="h-5 w-5 shrink-0 text-excel-500" /> {h}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
